<template>
    <div id="adddeliveryroutepage" class="delivery-route-edit">
        <div class="top-buttons">
            <ui5-button @click="addDeliveryRoute">{{ trans('pages.add_delivery_route.save') }}</ui5-button>
            <ui5-button @click="$router.push('/deliveryroutes')">
                {{ trans('pages.add_delivery_route.cancel') }}
            </ui5-button>
        </div>
        <div id="adddeliveryroutefields">
            <div>
                <ui5-label>{{ trans('pages.add_delivery_route.name') }}</ui5-label>
                <ui5-input
                    type="Text"
                    :value="name"
                    @input="name = $event.target.value" />
            </div>
            <div>
                <ui5-label for="description">{{ trans('pages.add_delivery_route.description') }}</ui5-label>
                <ui5-input
                    type="Text"
                    :value="description"
                    @input="description = $event.target.value" />
            </div>
        </div>
        <delivery-route-config-rules v-model="configRules" />
    </div>
</template>
<style>
#adddeliveryroutepage ui5-label {
    width: 100px;
}
</style>
<script>
import DeliveryRouteConfigRules from '../components/deliveryRoutes/DeliveryRouteConfigRules';
import deliveryRoutes from '../api/deliveryRoutes';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: { DeliveryRouteConfigRules },
    mixins: [localization],
    data() {
        return {
            name: '',
            description: '',
            configRules: [],
        };
    },
    methods: {
        addDeliveryRoute() {
            const name = this.name;
            const description = this.description;
            const configRules = this.configRules;

            if (!name || name.length <= 0) {
                return showErrorMessage(this.trans('pages.add_delivery_route.error_no_name'));
            }

            deliveryRoutes
                .addRoute(name, description, configRules)
                .then(() => {
                    this.$router.push('/deliveryroutes');
                })
                .catch(() => {
                    showErrorMessage(this.trans('pages.add_delivery_route.error_saving'));
                });
        },
    },
};
</script>
